import createSvgIcon from '@material-ui/core/utils/createSvgIcon';

const DocumentAdd = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 25"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM7 9h8v2H7zm0 3v2h8v-2h-3zm0 3h8v2H7z"
      clipRule="evenodd"
    />
  </svg>,
  'DocumentAdd'
);

export default DocumentAdd;

